export const ACTIVITIES = [
  { name: "Action Sports", value: "actionSports", selected: false },
  { name: "Archery", value: "archery", selected: false },
  { name: "Art", value: "art", selected: false },
  { name: "ASB", value: "asb", selected: false },
  { name: "Athletics", value: "athletics", selected: false },
  { name: "AVID", value: "avid", selected: false },
  { name: "Badminton", value: "badminton", selected: false },
  { name: "Band", value: "band", selected: false },
  { name: "Baseball", value: "baseball", selected: false },
  { name: "Basketball", value: "basketball", selected: false },
  { name: "Beach Volleyball", value: "beachVolleyball", selected: false },
  { name: "Bowling", value: "bowling", selected: false },
  { name: "Boxing", value: "boxing", selected: false },
  { name: "Business", value: "business", selected: false },
  { name: "Cheer", value: "cheer", selected: false },
  { name: "Cheerleading", value: "cheerleading", selected: false },
  { name: "Chess", value: "chess", selected: false },
  { name: "Choir", value: "choir", selected: false },
  { name: "Club", value: "club", selected: false },
  { name: "Crew", value: "crew", selected: false },
  { name: "Cross Country", value: "crossCountry", selected: false },
  { name: "Culture and Language", value: "cultureAndLanguage", selected: false },
  { name: "Cycling", value: "cycling", selected: false },
  { name: "Dance", value: "dance", selected: false },
  { name: "Debate", value: "debate", selected: false },
  { name: "DECA", value: "deca", selected: false },
  { name: "Drama", value: "drama", selected: false },
  { name: "Equestrian", value: "equestrian", selected: false },
  { name: "Fashion", value: "fashion", selected: false },
  { name: "FBLA", value: "fbla", selected: false },
  { name: "FCCLA", value: "fccla", selected: false },
  { name: "Fencing", value: "fencing", selected: false },
  { name: "Field Hockey", value: "fieldHockey", selected: false },
  { name: "Film and TV Production", value: "filmAndTvProduction", selected: false },
  { name: "Football", value: "football", selected: false },
  { name: "Freshman Class", value: "freshmanClass", selected: false },
  { name: "Girls Lacrosse", value: "girlsLacrosse", selected: false },
  { name: "Golf", value: "golf", selected: false },
  { name: "Gymnastics", value: "gymnastics", selected: false },
  { name: "Hockey", value: "hockey", selected: false },
  { name: "HOSA", value: "hosa", selected: false },
  { name: "Journalism", value: "journalism", selected: false },
  { name: "Junior Class", value: "juniorClass", selected: false },
  { name: "Key and Link", value: "keyAndLink", selected: false },
  { name: "Lacrosse", value: "lacrosse", selected: false },
  { name: "Marching Band", value: "marchingBand", selected: false },
  { name: "Martial Arts", value: "martialArts", selected: false },
  { name: "Merchandise", value: "merchandise", selected: false },
  { name: "Model UN and Trial", value: "modelUnAndTrial", selected: false },
  { name: "Music", value: "music", selected: false },
  { name: "National Honors Society", value: "nationalHonorsSociety", selected: false },
  { name: "Non Profit", value: "nonProfit", selected: false },
  { name: "Orchestra and Symphony", value: "orchestraAndSymphony", selected: false },
  { name: "Other", value: "other", selected: false },
  { name: "Outdoors", value: "outdoors", selected: false },
  { name: "Photography", value: "photography", selected: false },
  { name: "Powerlifting", value: "powerlifting", selected: false },
  { name: "Prom and Homecoming", value: "promAndHomecoming", selected: false },
  { name: "Robotics", value: "robotics", selected: false },
  { name: "ROTC", value: "rotc", selected: false },
  { name: "Rugby", value: "rugby", selected: false },
  { name: "Sailing", value: "sailing", selected: false },
  { name: "Scholarship", value: "scholarship", selected: false },
  { name: "Senior Class", value: "seniorClass", selected: false },
  { name: "Shooting", value: "shooting", selected: false },
  { name: "Skiing", value: "skiing", selected: false },
  { name: "Soccer", value: "soccer", selected: false },
  { name: "Softball", value: "softball", selected: false },
  { name: "Sophomore Class", value: "sophomoreClass", selected: false },
  { name: "STEM", value: "stem", selected: false },
  { name: "Student Government", value: "studentGovernment", selected: false },
  { name: "Surf", value: "surf", selected: false },
  { name: "Swim and Dive", value: "swimAndDive", selected: false },
  { name: "Tennis", value: "tennis", selected: false },
  { name: "Track And Field", value: "trackAndField", selected: false },
  { name: "Ultimate Frisbee", value: "ultimateFrisbee", selected: false },
  { name: "Video Game", value: "videoGame", selected: false },
  { name: "Volleyball", value: "volleyball", selected: false },
  { name: "Water Polo", value: "waterPolo", selected: false },
  { name: "Winter Sports", value: "winterSports", selected: false },
  { name: "Wrestling", value: "wrestling", selected: false },
  { name: "Writing", value: "writing", selected: false },
  { name: "Yearbook", value: "yearbook", selected: false },
];
